import {getConfig} from "../../Config";

export async function getTimeToConversion(period){

    let url = getConfig().serverUrl + "/getTimeToConversion/" + period;

    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function getBuysByDate(period){

    let url = getConfig().serverUrl + "/getBuysByDate/" + period;

    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function getMeasurementsByDate(period){

    let url = getConfig().serverUrl + "/getMeasurementsByDate/" + period;

    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function getUniqueLoginStatistics(period, platform, exclude, company){

    let url = getConfig().serverUrl + "/get"+platform+"Logins/" + period + "/" + exclude + "/" + company;

    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

export async function getSampleStatistics(period, exclude, company){

    let url = getConfig().serverUrl + "/getSamplesPerDate/" + period + "/" + exclude + "/" + company;

    return await fetch(url).then((response) => response.json()).then((responseJson) => {
        return responseJson;
    }).catch((error) => {
        console.error(error);
    });
}

